import store from '../story/'
/**
 * 存储localSession
 */
export const setSession = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}

/**
 * 获取localSession
 */
export const getSession = name => {
  if (!name) return
  return window.sessionStorage.getItem(name)
}
/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}
/**
 * 获取地址栏参数
 */
export const getQueryString = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return decodeURI(r[2]); return null
}

/**
 * 补0
 */
export const islength = (num) => {
  if (Number(num) < 10) {
    return '0' + num
  } else {
    return num
  }
}

/**
 * 表单校验
 */
export const rule = {
  alert: function (mess) {
    store.state.alertMessage = mess
    store.state.showAlert = true
  },
  empty: function (str, mess) { // 不能为空
    if (str == '') {
      this.alert(mess)
      return false
    } else {
      return true
    }
  },
  phone: function (str) { // 手机号校验
    var myReg = /^(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
    if (!myReg.test(str)) {
      this.alert('手机号码有误')
      return false
    } else {
      return true
    }
  }

}

export const overscroll = els => {
  for (var i = 0; i < els.length; ++i) {
    console.log(els)
    var el = els[i]
    el.addEventListener('touchstart', function () {
      var top = this.scrollTop
        , totalScroll = this.scrollHeight
        , currentScroll = top + this.offsetHeight
        , left = this.scrollLeft
        , totalScrollWidth = this.scrollWidth
        , currentScrollWidth = top + this.offsetWidth
      if (top === 0) {
        this.scrollTop = 1
      } else if (currentScroll === totalScroll) {
        this.scrollTop = top - 1
      }

      if (left === 0) {
        this.scrollleft = 1
      } else if (currentScrollWidth === totalScrollWidth) {
        this.scrollleft = left - 1
      }

    })
    el.addEventListener('touchmove', function (evt) {
      if (this.offsetHeight < this.scrollHeight) {
        evt._isScroller = true
      }
      if (this.offsetWidth < this.scrollWidth) {
        evt._isScroller = true
      }
    })
  }
}//禁止body的滚动事件

let startPageX = 0
document.body.addEventListener('touchstart', function (evt) {
  startPageX = evt.touches[0].pageX
})

document.body.addEventListener('touchmove', function (evt) {

  let movePageX = evt.touches[0].pageX
  console.log(!evt._isScroller)
  if (!evt._isScroller) {
    evt.preventDefault()
  }
}, {
  passive: false
})

//给class为.scroll的元素加上自定义的滚动事件
//overscroll(document.querySelectorAll('.scroll'));

// 删除数组指定的某个元素
Array.prototype.remove = function (val) {
  var index = this.indexOf(val)
  if (index > -1) {
    this.splice(index, 1)
  }
}

// 数组去重
export const unique = (arr) => {
  return arr.filter((element, index, self) => { return self.indexOf(element) === index })
}

Date.prototype.format = function (format) {
  var o = {
    'M+': this.getMonth() + 1,  // month
    'd+': this.getDate(),     // day
    'h+': this.getHours(),    // hour
    'm+': this.getMinutes(),  // minute
    's+': this.getSeconds(), // second
    'q+': Math.floor((this.getMonth() + 3) / 3),  // quarter
    'S': this.getMilliseconds() // millisecond
  }
  var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(w+)/.test(format)) {
    format = format.replace(RegExp.$1, week[this.getDay()])
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}

Date.prototype.add = function (part, value) {
  value *= 1
  if (isNaN(value)) {
    value = 0
  }
  switch (part) {
    case 'y':
      this.setFullYear(this.getFullYear() + value)
      break
    case 'm':
      this.setMonth(this.getMonth() + value)
      break
    case 'd':
      this.setDate(this.getDate() + value)
      break
    case 'h':
      this.setHours(this.getHours() + value)
      break
    case 'n':
      this.setMinutes(this.getMinutes() + value)
      break
    case 's':
      this.setSeconds(this.getSeconds() + value)
      break
    default:

  }
  return this
}

// alert(new Date().add("m", -1).format('yyyy-MM-dd hh:mm:ss'));

/**
 * 显示返回顶部按钮，开始、结束、运动 三个过程中调用函数判断是否达到目标点
 */
export const showBack = (el, callback) => {
  let requestFram
  let oldScrollTop

  document.addEventListener('scroll', () => {
    showBackFun()
  }, false)
  document.addEventListener('touchstart', () => {
    showBackFun()
  }, {passive: true})

  document.addEventListener('touchmove', () => {
    showBackFun()
  }, {passive: true})

  document.addEventListener('touchend', () => {
    oldScrollTop = el.getPosition().top
    moveEnd()
  }, {passive: true})

  const moveEnd = () => {
    requestFram = requestAnimationFrame(() => {
      if (el.getPosition().top != oldScrollTop) {
        oldScrollTop = el.getPosition().top
        moveEnd()
      } else {
        cancelAnimationFrame(requestFram)
      }
      showBackFun()
    })
  }

  // 判断是否达到目标点
  const showBackFun = () => {
    if (el.getPosition().top > 500) {
      callback(true)
    } else {
      callback(false)
    }
  }
}

export const toast = (msg = '', time = 1500) => {
  var toast = document.createElement('div')
  toast.className = 'common-toast common-toast-show'
  toast.innerHTML = msg
  document.body.appendChild(toast)
  toast.style.display = 'block'
  toast.style.margin = `-${toast.offsetHeight / 2}px 0 0 -${toast.offsetWidth / 2}px`
  var timer = setTimeout(() => {
    toast.className = 'common-toast common-toast-hide'
    clearTimeout(timer)
    var timer2 = setTimeout(() => {
      document.body.removeChild(toast)
      clearTimeout(timer2)
    }, 200)
  }, time)
}

const digitsRE = /(\d{3})(?=\d)/g

export function currency (value, currency, decimals) {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : '$'
  decimals = decimals != null ? decimals : 2
  var stringified = Math.abs(value).toFixed(decimals)
  var _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  var i = _int.length % 3
  var head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  var _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  var sign = value < 0 ? '-' : ''
  return sign + currency + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float
}

/**
 * 检查是否为Emoji
 */
export const isEmoji = name => {
  if (escape(name).toLocaleLowerCase().match(/(\%\ue[0-9a-f]{3})|(\%\ud[0-9a-f]{3})/)) {
    return true
  } else {
    return false
  }
}

/**微信分享
 * @param files
 */
export const wxshare = (wx, shareCont) => {
  let title = shareCont.title
  let shareContent = shareCont.shareContent
  let url = shareCont.url
  let imgUrl = shareCont.imgUrl
  wx.ready(function () {
    wx.checkJsApi({
      jsApiList: [
        'onMenuShareTimeline', // 分享到朋友圈
        'onMenuShareAppMessage', // 分享给好友
        'onMenuShareQQ', // 分享到QQ
        'onMenuShareWeibo', // 分享到微博
        'onMenuShareQZone' // 分享到QQ空间
      ]
    })
    wx.onMenuShareTimeline({
      title: title, // 分享标题
      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function () {
        toast('分享成功')
      },
      cancel: function () {
        toast('取消分享')
      }
    })
    wx.onMenuShareAppMessage({
      title: title, // 分享标题
      desc: shareContent, // 分享描述
      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      type: 'link', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        toast('分享成功')
      },
      cancel: function () {
        toast('取消分享')
      }
    })
    wx.onMenuShareQQ({
      title: title, // 分享标题
      desc: shareContent, // 分享描述
      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function () {
        toast('分享成功')
      },
      cancel: function () {
        toast('取消分享')
      }
    })
    wx.onMenuShareWeibo({
      title: title, // 分享标题
      desc: shareContent, // 分享描述
      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function () {
        toast('分享成功')
      },
      cancel: function () {
        toast('取消分享')
      }
    })
    wx.onMenuShareQZone({
      title: title, // 分享标题
      desc: shareContent, // 分享描述
      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function () {
        toast('分享成功')
      },
      cancel: function () {
        toast('取消分享')
      }
    })
  })
}


// WEBPACK FOOTER //
// ./src/config/mUtils.js